module.exports = __webpack_public_path__ + "media/images/webdesign/gerika_logo-10e1d294f79fe674bb94d705a26bd904.png";